export default "__VITE_ASSET__db3c2143__"